export default {
  getList: (state) => {
    return state.fields;
  },
  getRefs: (state) => {
    return state.refs
  },
  isEmpty: (state) => {
    return state.fields.length === 0;
  },
  getFieldByStep: (state) => (stepNumber) => {
    return state.fields.find((e) => e.number === stepNumber)
  },
  getValue: (state, getters) => ({ step, blockIndex, itemIndex, blockUnique, itemCode }) => {
    const field = getters.getFieldByStep(step)
    let block;
    let item;

    if (blockUnique) {
      block = field?.blocks?.find((e) => e.unique === blockUnique);
    } else {
      block = field?.blocks[blockIndex];
    }

    if (itemCode) {
      item = block?.items?.find((e) => e.code === itemCode);
    } else {
      item = block?.items[itemIndex];
    }

    return item?.value ?? []
  },
  getFieldVideoPathByStep: (state, getters) => (stepNumber) => {
    return getters.getFieldByStep(stepNumber)?.video ?? ''
  },
  getMessageFieldByStep: (state) => (stepNumber) => {
    return state.messagesFields[stepNumber]
  },
  getNumberOfRequiredSteps: (state) => {
    return state.requiredSteps
  },
  typeOfDocument: (state) => {
    return state.typeOfDocument
  },
  progress: (state) => {
    return state.check
  },
  status: (state) => {
    return state.status
  },
  getData: (state) => {
    return state.data
  },
  getDataAlt: (state) => {

    let stepIndex = state.fields.findIndex(step => step.number === state.stepNum);

    if (stepIndex === -1) {
      return [];
    }
    let fields = [];

    state.fields?.[stepIndex]?.blocks?.forEach(block => {
      block.items?.forEach(field => {
        fields.push({
          type: field.type,
          value: field.value,
          code: field.code,
          id: field.id,
          blockActive: block.display
        });
      });
    });
    return fields;
  },
  getResidencyFill: (state) => {
    return state.residencyFill
  },
  getRFDocuments: (state) => {
    return state.guidDocumentsRf;
  },
  getRFGuid: (state) => {
    return state.guidRf;
  },
  getRegistrationCountry: (state) => {
    return state.registrationCountry;
  },
  getResidencyCountry: (state) => {
    return state.residencyCountry;
  },
  isDocumentTypeEqualsRF: (state, getters) => {
    return getters.getRFDocuments.includes(getters.typeOfDocument);
  },
  isPrevDocumentTypeEqualsRF: (state, getters) => {
    return getters.getRFDocuments.includes(getters.getTypeOfPrevDocument);
  },
  isRepresentativeDocumentTypeEqualsRF: (state) => {
    //FIXME +
    let RepresentativeDocumentType = null;
    state.fields.forEach(field => {
      field.blocks.forEach(block => {
        RepresentativeDocumentType = Array.isArray(block.items) && block.items.filter(item => item.code === "REPRESENTATIVE_DOCUMENT_TYPE")[0]?.value;
      })
    })

    return state.refs[RepresentativeDocumentType] === state.guidPassportRf;
  },
  isAttornyDocumentTypeEqualsRF: (state) => {
    //FIXME +
    let AttornyDocumentType = null;
    state.fields.forEach(field => {
      field.blocks.forEach(block => {
        AttornyDocumentType = Array.isArray(block.items) && block.items.filter(item => item.code === "ATTORNY_DOCUMENT_TYPE")[0]?.value;
      })
    })

    return state.refs[AttornyDocumentType] === state.guidPassportRf;
  },
  getCompetitionGroups: (state) => {
    return state.competitionGroupList;
  },
  getSelectedCompetitionGroup: (state) => {
    return state.selectedCompetitionGroup;
  },
  getGUIDSelectedCompetitionGroupById: (state) => (idCg) => {
    const normalizeIdCg = Number.parseInt(idCg)
    const item = state.selectedCompetitionGroupGUID?.find((e) => e.competitionGroupId === normalizeIdCg);
    return item ? item.GUID : null
  },
  getIdSelectedCompetitionGroupByGUID: (state) => (GUID) => {
    const item = state.selectedCompetitionGroupGUID?.find((e) => e.GUID === GUID);
    return item ? item.competitionGroupId : null
  },
  getGUIDSelectedCompetitionGroup(state) {
    return state.selectedCompetitionGroupGUID
  },
  getLastStepFields: (state) => {
    let fields = [];
    state.fields[state.fields.length - 1].blocks.forEach(block => {
      block.items.forEach(field => {
        fields.push({
          type: field.type,
          value: field.value,
          placeType: field.placeType ?? ''
        });
      });
    });
    return fields;
  },
  getTypeOfPrevDocument: (state) => {
    return state.typeOfPrevDocument;
  },
  getBirthDate: (state) => {
    return state.birthDate;
  },
  getCheckingData: (state) => {
    return state.check
  },
  getActionsButton: (state) => {
    return state.actionsButton
  },
  getActiveCheckBox: (state) => {
    return state.activeCheckBox
  },
  getSelectedBwe: (state) => {
    return state.selectedBwe
  },
  getSelectedOlympic: (state) => {
    return state.selectedOlympic
  },
  getStepNum: (state) => {
    return state.stepNum;
  },
  getCompetitiveGroups: (state) => {
    return state.competitiveGroups
  },
  getCreativeET: (state) => {
    return state.creativeET;
  },
  getcodesWhenUpdate: (state) => {
    return state.codesWhenUpdate
  },
  getValidationErrors: (state) => {
    return state.validationErrors
  },
  getSavedFileByKey: (state) => (key) => {
    return state.savedFiles[key]
  },
  getAppFormViewMode(state) {
    return state.formViewMode;
  },
  getInitFieldsState(state) {
    return state.isInitFields;
  },
  getGuidExtraQuotaType(state) {
    return state.guidExtraQuotaType;
  }
};
